import { defineComponent as _defineComponent } from 'vue'
import { ref, computed, inject, Ref } from 'vue';

import {
  HeadingDisplay,
  BaseText,
  ContentDisplay,
  ListDisplay,
  ButtonContainer,
  ButtonPrimary,
  ButtonSecondary
} from '@warrenbrasil/nebraska-web';
import { NebraskaColors } from '@warrenbrasil/nebraska-tokens-web';
import { SingleInputMoney } from '@/modules/common/components/SingleInputMoney';

import { IPortfolioSheetData } from '@/modules/catalog/services/variable-income';


export default /*#__PURE__*/_defineComponent({
  __name: 'Investment',
  setup(__props) {

const investLater = inject('investLater', () => ({}));
const changeAmountValue = inject(
  'changeAmountValue',
  (value: number, formatted: string) => ({ value, formatted })
);

const portfolioSheetData = inject(
  'portfolioSheetData'
) as Ref<IPortfolioSheetData>;
const isCreatingPortfolio = inject('isCreatingPortfolio') as Ref<boolean>;

const amountFormatted = ref('');
const amountValue = ref(0);

const isDisabled = computed(() => {
  return (
    amountValue.value <= 0 ||
    status.value === 'error' ||
    isCreatingPortfolio.value
  );
});

const minimumInvestment = computed(() => {
  return portfolioSheetData.value.investment.minimumInvestment.value;
});

const availableBalance = computed(() => {
  return portfolioSheetData.value.investment.availableBalance.value;
});

const status = computed(() => {
  return (amountValue.value < minimumInvestment.value &&
    amountValue.value !== 0) ||
    amountValue.value > availableBalance.value
    ? 'error'
    : '';
});

const helperText = computed(() => {
  if (amountValue.value < minimumInvestment.value && amountValue.value !== 0)
    return `O valor mínimo de investimento nesta carteira é ${portfolioSheetData.value.investment.minimumInvestment.formatted}`;
  if (amountValue.value > availableBalance.value)
    return `Valor maior que o saldo disponível: ${portfolioSheetData.value.investment.availableBalance.formatted}`;

  return '';
});

function investClick() {
  changeAmountValue(amountValue.value, amountFormatted.value);
}

function investLaterClick() {
  investLater();
}

function onChangeValue(data: { value: number; formatted: string }) {
  amountFormatted.value = data.formatted;
  amountValue.value = data.value;
}

return { __sfc: true,investLater, changeAmountValue, portfolioSheetData, isCreatingPortfolio, amountFormatted, amountValue, isDisabled, minimumInvestment, availableBalance, status, helperText, investClick, investLaterClick, onChangeValue, HeadingDisplay, BaseText, ContentDisplay, ListDisplay, ButtonContainer, ButtonPrimary, ButtonSecondary, NebraskaColors, SingleInputMoney }
}

})